import { useTreatmentsInternalUse } from 'store/slices/treatments/selector';

/**
 *
 * @param string splitName
 * @returns {boolean} depending on whether the split is enabled or not, treatments object if no splitName is provided
 */
export const useTreatments = (splitName) => {
	const treatments = useTreatmentsInternalUse();
	return splitName ? treatments[splitName] === 'on' : treatments;
};

/**
 *
 * @param string splitName
 * @returns {boolean} treatments object value for splitName
 */
export const useIsTreatmentsEqualsTo = (splitName, expectedValue) => {
	const treatments = useTreatmentsInternalUse();
	return treatments[splitName] === expectedValue;
};

export default useTreatments;
